"use client";
import React from "react";
import PropTypes from "prop-types";
import {
  ButtonItem,
  Title,
  InText,
  ItemData,
  Segmant,
  Wcomment,
  NewItemData,
  NewButtonItem,
} from "../../components";
import SplitText from "./SplitText";
import { Grid, Divider, Icon, Dropdown, Label } from "semantic-ui-react";
// import Link from "next/link";
import { styles } from "./element";

import { customdecodeURIComponent } from "../../common/Utils";

const EditorDescription = ({
  desData,
  review,
  isEditor,
  userId,
  onEditreview,
  onDeletereview,
  cityname,
  statename,
  isnh,
  cityfullname,
}) => {
  let max = desData.length;
  let data = desData;
  return (
    <div>
      {data &&
        data.length > 0 &&
        data.map((grid, index) => (
          <div key={index}>
            <p style={styles.description}>
              {customdecodeURIComponent(grid.description)}
            </p>
            {grid.UserID === userId && (
              <div>
                <ButtonItem
                  size="small"
                  //color="#c02e26"
                  icon
                  labelPosition="right"
                  //floated="left"
                  onClick={(e) => onEditreview(e, grid)}
                  className="btn_blue_bg"
                >
                  Edit <Icon name="write" className="btn_blue_bg" />
                </ButtonItem>

                <ButtonItem
                  size="small"
                  //color="#c02e26"
                  icon
                  labelPosition="right"
                  //floated="left"
                  onClick={(e) => onDeletereview(e, grid)}
                  className="btn_blue_bg"
                >
                  Delete
                  <Icon name="delete" className="btn_blue_bg" />
                </ButtonItem>
              </div>
            )}
          </div>
        ))}

      <div className="no_review_sec">
        {/* {isEditor && data.length <= 0 && (
          <ButtonItem
            as="div"
            labelPosition="right"
            floated="left"
            onClick={(e) => review(e)}
            className="theme_blue btn_blue"
          >
            <ButtonItem
              //color="#1b57a5"
              icon="write"
              className="btn_blue_bg"
            />
            <Label
              as="a"
              name="saveNeighbor"
              content="Write a Review"
              basic
              //color="#1b57a5"
              pointing="left"
              className="theme_blue btn_blue"
            />
          </ButtonItem>
        )} */}

        {data.length <= 0 && !isEditor && (
          <div className="no_reviews_blk">
            <h4>
              Houseberry is analyzing everything that makes this neighborhood
              sweet - our take is coming soon
            </h4>
          </div>
        )}
      </div>
      {isnh && (
        <div className="city_txt_btm">
          <span>
            See City Review for:{" "}
            <a href={`/City/${cityfullname}`} target="_blank" title={cityname}>
              {cityname}
            </a>
          </span>
        </div>
      )}
    </div>
  );
};

EditorDescription.propTypes = {
  desData: PropTypes.array.isRequired,
};

export default EditorDescription;
